import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import { createTheme } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/styles";

const GreenCheckbox = withStyles({
  root: {
    padding: "0 7px 0 0",
    color: green[400],
    "&$checked": {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const useStyles = makeStyles({
  main: {
    margin: "14px 0",
    width: "100%",
  },
  title: {
    color: "#000000db",
    fontWeight: "bold",
    margin: "12px 0",
  },
  description: {
    color: "#000000db",
    marginLeft: "32px",
    margin: "0",
  },
});

const theme = createTheme({
  overrides: {
    MuiFormControlLabel: {
      label: {
        fontSize: 18,
        fontWeight: 500,
      },
    },
  },
});

let today = new Date();
let dd = today.getDate();
let mm = today.getMonth() + 1;
const yyyy = today.getFullYear();
if (dd < 10) {
  dd = "0" + dd;
}
if (mm < 10) {
  mm = "0" + mm;
}
today = dd + "/" + mm + "/" + yyyy;

export default function CheckboxDebitAutomaticRegister(props) {
  const classes = useStyles();
  const [state, setState] = React.useState({
    checkedDebitAccount: false,
    checkedNoMixed: false,
  });

  const handleChange = (name) => (event) => {
    setState({ ...state, [name]: event.target.checked });

    if (name === "checkedDebitAccount")
      props.getCheckboxAutorization(event.target.checked);
    if (name === "checkedNoMixed")
      props.getCheckboxNonMixed(event.target.checked);
  };

  return (
    <div className={classes.main}>
      {props.type === "debitoEmConta" && (
        <FormGroup row class="col-12">
          <ThemeProvider theme={theme}>
            <FormControlLabel
              className={classes.title}
              control={
                <GreenCheckbox
                  checked={state.checkedDebitAccount}
                  onChange={handleChange("checkedDebitAccount")}
                  value="checkedDebitAccount"
                />
              }
              label="INSTRUMENTO DE AUTORIZAÇÃO PARA DÉBITO EM CONTA"
            />
          </ThemeProvider>
          <p className={classes.description}>
            Autoriza que seja debitado mensalmente, no dia do vencimento, o
            valor referente ao(s) tributo(s) aqui relacionado(s) na conta
            corrente de sua titularidade, indicada acima.
            <br />
            Reconhece-se que o serviço está efetivado apenas para os débitos com
            data de vencimento a partir de {today}, se não existir
            impropriedades nos dados bancários informados.
            <br /> No caso de insuficiência de saldo na data do vencimento, o
            débito ficará em aberto, ficando sob sua responsabilidade a quitação
            por outras formas de pagamento (Impressão de boleto de DAM ou
            Pagamento Online).
            <br />
            Na hipótese de solicitação de cancelamento do serviço de débito
            automático, concorda que os débitos com data de vencimento prevista
            até dois dias após a data da solicitação possam ainda ser submetidos
            a sistemática de débito automático.
          </p>
        </FormGroup>
      )}
      {props.type === "bancoMisto" && (
        <FormGroup row class="col-12">
          <ThemeProvider theme={theme}>
            <FormControlLabel
              className={classes.title}
              control={
                <GreenCheckbox
                  checked={state.checkedNoMixed}
                  onChange={handleChange("checkedNoMixed")}
                  value="checkedNoMixed"
                />
              }
              label="INSTRUÇÃO PARA CADASTRAMENTO EM DÉBITO AUTOMÁTICO PARA O BANCO SELECIONADO"
            />
          </ThemeProvider>
          <p className={classes.description}>
            1. Aperte o botão "CONFIRMAR &gt;&gt;" para imprimir o código de
            identificação para o débito automático.
          </p>
          <p className={classes.description}>
            2. Compareça a sua agência portando identidade, CPF e o código de
            identificação gerado.
          </p>
          <p className={classes.description}>
            3. No caso de alteração dos dados bancários o cancelamento do
            serviço, procure o seu gerente.
          </p>
        </FormGroup>
      )}
    </div>
  );
}
